import API from '@/api';
import qs from 'qs';

class Main
{
  static async details(id, query = {}) {
    return await API.dispatch(
      'GET',
      'missionDetails',
      {
        path: { id },
        query
      }
    );
  }

  static async related(id) {
    return await API.dispatch(
      'GET',
      'missionRelated',
      {
        path: { id }
      }
    );
  }

  static async visit(id) {
    return await API.dispatch(
      'POST',
      'missionVisited',
      {
        path: { id }
      }
    );
  }

  static async getQuestions(id) {
    return await API.dispatch(
      'GET',
      'missionQuestions',
      {
        query: {
          mission_id: id
        }
      }
    );
  }

  static async isDonationEligible(id) {
    return await API.dispatch(
      'GET',
      'missionDonationEligible',
      {
        path: { id }
      }
    );
  }

  static async getShifts(query, id) {
    return await API.dispatch(
      'GET',
      'missionShifts',
      {
        query,
        path: { id }
      }
    );
  }

  static async timesheetSummary(payload) {
    return await API.dispatch(
      'GET',
      'missionsTimesheetsSummary',
      {
        query: payload,
        custom: {
          paramsSerializer: params => {
            return qs.stringify(params)
          }
        }
      }
    );
  }
}

export default Main;